import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import isUsingArtemisStyles from '../../v2/selectors/isUsingArtemisStyles';
import MediaQueries from '../../v2/style-helper/MediaQueries';
import Spacing from '../../v2/style-helper/Spacing';

const getBackgroundColour = (props) => {
  if ((props.hasBackgroundColour && !!props.theme.orderSummary.backgroundColor)
    || !!props.theme.surfaceBackgroundColour) {
    return props.hasBackgroundColour ? props.theme.orderSummary.backgroundColor : props.theme.surfaceBackgroundColour;
  } return '#fff';
};

const ArtemisStyles = props => ({
  borderColor: props.theme.surfaceHighlightOverride || props.theme.surfaceHighlight,
});

const useStyles = createUseStyles({
  surface: {
    transition: '0.3s box-shadow, 0.3s border',
    padding: Spacing.triple,
    margin: [Spacing.quad, 0],
    boxShadow: props => props.theme.hasSurfaceBoxShadow && [
      [0, 1, 3, 0, 'rgba(0, 0, 0, 0.2)'],
      [0, 2, 1, -1, 'rgba(0, 0, 0, 0.12)'],
      [0, 1, 1, 0, 'rgba(0, 0, 0, 0.14)'],
    ],
    backgroundColor: getBackgroundColour,
    
    // I couldn't get function values _and_ property expansion syntax working together
    borderStyle: 'solid',
    borderColor: props => props.theme.hasSurfaceHighlight && props.theme.surfaceHighlight,
    borderTopWidth: props => (props.theme.hasSurfaceHighlight && props.active) && Spacing.half,
    
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.hasSurfaceHighlight) && ArtemisStyles(props),
    }),
  },
  
  [MediaQueries.phone]: {
    surface: {
      margin: [Spacing.triple, 0],
      marginTop: props => props.noMarginTop && 0,
    },
  },
});

export function Surface(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  return (
    <div className={classes.surface}>
      {props.children}
    </div>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

Surface.propTypes = {
  hasBackgroundColour: PropTypes.bool,
  children: PropTypes.node.isRequired,
  noMarginTop: PropTypes.bool,
};

export default connect(mapStateToProps)(Surface);
